module.exports = __webpack_public_path__ + "static/braimoh-fc1f77f2c9ae4dd21940152aea2a961e.png";